export const WEATHER_NO_DATA_MESSAGE = "Нет данных о погоде в данной точке";

export function isWeatherNoDataError(error) {
    const status = error?.response?.status;
    const code = error?.response?.data?.error;
    return status === 404 && (code === "no_weather_data" || code === "no_locations");
}

export function getWeatherApiErrorMessage(error, fallback) {
    if (isWeatherNoDataError(error)) {
        return WEATHER_NO_DATA_MESSAGE;
    }

    const code = error?.response?.data?.error;
    if (code === "invalid_coordinates") {
        return "Некорректные координаты.";
    }

    return fallback;
}
